import { createContext } from "react";

export type UserProps = {
    user: {
        roleId: number;
        roleName: string;
        userId: string;
        userName: string;
    };
};

export const UserContext = createContext<UserProps>({
    user: {
        roleId: 0,
        roleName: "",
        userId: "",
        userName: "",
    },
});
